/** Routing paths */
export const PATHS = {
  HOME: 'home',
  SUMMARY: 'summary',
  IN_PROGRESS: 'in-progress',
  ACADEMICS: 'academic-progress',
  ADMISSIONS: 'admissions',
};

export const DPM_SENTRY_PRODUCT_TAG = { product: 'dpm' };
export const DPMPT_SENTRY_PRODUCT_TAG = { product: 'dpm-pt' };
